export const SupabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || "";
if (!SupabaseUrl) {
	throw new Error(
		"Missing Supabase URL. Please ensure NEXT_PUBLIC_SUPABASE_URL is set.",
	);
}

export const SupabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || "";
if (!SupabaseKey) {
	throw new Error(
		"Missing Supabase anon key. Please ensure NEXT_PUBLIC_SUPABASE_ANON_KEY is set.",
	);
}
